import BaseInput, { BaseInputProps } from "./BaseInput";
import TextArea from "./TextArea";
interface CompoundedComponent
  extends React.ForwardRefExoticComponent<BaseInputProps> {
  TextArea: typeof TextArea;
}

export const stausClass = {
  success:
    "border-success focus:border-success text-success hover:border-success hover:text-success placeholder:text-success",
  warning:
    "border-warning focus:border-warning text-warning hover:border-warning hover:text-warning placeholder:text-warning",
  done: "border-done focus:border-done text-done hover:border-done hover:text-done placeholder:text-done",
  error:
    "border-error focus:border-error text-error hover:border-error hover:text-error placeholder:text-error",
  pink: "border-pink focus:border-pink text-pink hover:border-pink hover:text-pink placeholder:text-pink",
  bg: "border-bg focus:border-bg text-bg hover:border-bg hover:text-bg placeholder:text-bg",
  default: "",
};

const Input = BaseInput as CompoundedComponent;

Input.TextArea = TextArea;
export default Input;
